import { MODELS } from './settings';

export const PER_PAGE_OPTION_1 = 5;
export const PER_PAGE_OPTION_2 = 10;
export const PER_PAGE_OPTION_3 = 20;
export const RESULTS_PER_PAGE_OPTIONS = [PER_PAGE_OPTION_1, PER_PAGE_OPTION_2, PER_PAGE_OPTION_3];

export const TABLE_INDICES = {
    [MODELS.TEMPLATE]: 1,
    [MODELS.EVENT_EMAIL_SENDER]: 1
};

export const LARGE_COLUMNS = {
    [MODELS.EVENT]: ['Organization.name']
};

export const SMALL_COLUMNS = {};

export const HEADERS = {
    [MODELS.ORGANIZATION]: [
        {
            label: 'Name',
            key: 'name'
        }
    ],
    [MODELS.PARTNER]: [
        {
            label: 'Name',
            key: 'name'
        }
    ],
    [MODELS.ARTIST_CONTACTS]: [
        {
            label: 'Name',
            key: 'fullName'
        },
        { label: 'Email', key: 'email' },
        { label: 'Type', key: 'type' },
        { label: 'Permission', key: 'permission' },
        { label: 'Performance contracts access', key: 'accessToPerformanceContracts' }
    ],
    [MODELS.EVENT_PARTNER]: [
        {
            label: 'Name',
            key: 'name'
        }
    ],
    [MODELS.CONTACT]: [
        {
            label: 'Name',
            key: 'fullName'
        },
        {
            label: 'Email',
            key: 'email'
        }
    ],
    [MODELS.EVENT]: [
        {
            label: 'Organization',
            key: 'Organization.name'
        },
        {
            label: 'Event',
            key: 'name'
        }
    ],
    [MODELS.EVENT_EMAIL_SENDER]: [
        {
            label: 'Sender Name',
            key: 'name'
        },
        {
            label: 'Sender Email',
            key: 'email'
        },
        {
            label: 'Verified',
            key: 'verified'
        }
    ],
    [MODELS.PERMISSION]: [
        {
            label: 'Type',
            key: 'function'
        },
        {
            label: 'Group',
            key: 'group'
        },
        {
            label: 'Permission',
            key: 'name'
        },
        {
            label: 'Organization',
            key: 'organizationName'
        },
        {
            label: 'Event',
            key: 'eventName'
        }
    ],
    [MODELS.IMPORT]: [
        {
            label: 'Organization',
            key: 'organization'
        },
        {
            label: 'Uploaded by',
            key: 'uploadedBy'
        },
        {
            label: 'Event',
            key: 'event'
        },
        {
            label: 'Mediapartner',
            key: 'partner'
        },
        {
            label: 'Last upload',
            key: 'startTime'
        },
        {
            label: 'Status',
            key: 'status'
        }
    ],
    [MODELS.ARTIST]: [{ label: 'Artist Group', key: 'name' }],
    [MODELS.EVENT_ARTIST]: [
        { label: 'Artist Group', key: 'name' },
        { label: 'Contract Status', key: 'contract' }
    ],
    [MODELS.CONTRACT]: [
        {
            label: 'Event',
            key: 'eventName'
        },
        {
            label: 'Artist',
            key: 'artistName'
        },
        {
            label: 'Due Date',
            key: 'dueDate'
        },
        {
            label: 'Last Modified',
            key: 'updatedAt'
        },
        {
            label: 'Last Reminder',
            key: 'lastReminderDate'
        },
        {
            label: 'Notes',
            key: 'notes'
        },
        {
            label: 'Status',
            key: 'state'
        },
        {
            label: 'Artist Remarks',
            key: 'hasComments'
        }
        // TODO-NT
        // {
        //     label: 'Errors',
        //     key: 'errors',
        //     disableSort: true
        // }
    ],
    [MODELS.CONTRACT_PARTNER]: [
        { label: 'Partner Name', key: 'partnerName' },
        { label: 'Type', key: 'partnerType' },
        { label: 'Live Clearance', key: 'live' },
        { label: 'Non Linear Clearance', key: 'nonLinear' },
        // { label: 'Use Until', key: 'useUntil' },
        { label: 'Comments', key: 'comments' }
    ],
    [MODELS.TEMPLATE]: [
        { label: 'Organization', key: 'organizationName' },
        { label: 'Name', key: 'name' },
        { label: 'Type', key: 'type' }
    ],
    [MODELS.EVENT_EMAIL]: [
        {
            label: 'Email Type',
            key: 'humanType'
        },
        {
            label: 'Receiver',
            key: 'receiver'
        },
        {
            label: 'Sender Name',
            key: 'senderName'
        }
    ],
    [MODELS.ARTIST_PARTNER_CONTACT]: [
        {
            label: 'Name',
            key: 'fullName'
        },
        {
            label: 'Email',
            key: 'email'
        },
        {
            label: 'Function',
            key: 'functionName'
        }
    ],
    [MODELS.EVENT_REMINDER]: [
        {
            label: 'Reminder Name',
            key: 'name'
        },
        {
            label: 'Contract Type',
            key: 'contractType'
        },
        {
            label: 'Time Before Due Date',
            key: 'dueDate'
        },
        {
            label: 'Comments',
            key: 'comments'
        }
    ]
};

export const DEFAULT_SORT = {
    [MODELS.ARTIST]: { field: 'name' },
    [MODELS.TEMPLATE]: { field: 'name' },
    [MODELS.PARTNER]: { field: 'name' },
    [MODELS.CONTACT]: { field: 'name' },
    [MODELS.ARTIST_PARTNER_CONTACT]: { field: 'name' },
    [MODELS.ORGANIZATION]: { field: 'name' },
    [MODELS.EVENT]: { field: 'name' },
    [MODELS.CONTRACT]: { field: 'updatedAt', direction: '-' }
};



// WEBPACK FOOTER //
// ./src/constants/admin/tables.js